import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useSelectMeetingDate = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const selectMeetingDate = async ({ requestId, body }) => {
    if (!token) throw new Error("Token is missing");
    if (!requestId) throw new Error("Request ID is required");
    if (!body.date1 || !body.date2) throw new Error("Both date1 and date2 are required");
    
    const endpoint = `${process.env.REACT_APP_SERVER_URL}/charter/vesselOwner/selectMeetingDate/${requestId}`;
    const response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to select meeting date");
    }
    return data;
  };

  const {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  } = useMutation(selectMeetingDate, {
    onSuccess: () => {
      // Invalidate and refetch charter requests to get updated data
      queryClient.invalidateQueries(["readAllCharterRequestsVesselOwner"]);
      queryClient.invalidateQueries(["readCharterRequestVesselOwner"]);
    },
  });

  return {
    selectMeetingDate: mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export default useSelectMeetingDate; 